export default __webpack_public_path__ + "static/media/icon-drone.08dad9fd.png";